module.exports = __webpack_public_path__ + "static/media/temple.53db8066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/temple.jpg
// module id = 522
// module chunks = 0